module.exports = __webpack_public_path__ + "static/media/vintage03.589bee73.png";